export var validateSingleLineTextValue = function validateSingleLineTextValue(value) {
  return typeof value === 'string';
};